import { ActionReducerMapBuilder, Draft, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NoInfer } from '@reduxjs/toolkit/src/tsHelpers';

import { ModelError, State } from 'models';

import { GeoJSONFeatureCollection } from 'ol/format/GeoJSON';

import {
  FulfilledActionType,
  PendingActionType,
  RejectedActionType,
  errorOr,
  fulfilled,
  pending,
  rejected
} from './storeHelpers';

import { BaseApi } from 'api/baseApi';

export const convertGeoJSONToGeopackage = createAsyncThunk<string, FormData, { rejectValue: ModelError }>(
  'post/inventering/convertGeopackageToGeoJSON',
  async (data: FormData, { rejectWithValue }) => {
    const result = await BaseApi.geojson2geopackage(data);

    return errorOr<string>(result, rejectWithValue, undefined, true);
  }
);

const initialState: State<GeoJSONFeatureCollection | undefined> = {
  requestStatus: 'idle',
  requestType: undefined,
  currentRequestId: undefined,
  data: undefined,
  error: undefined
};

const geoJSONToGeopackageSlice = createSlice({
  name: 'geoJSONToGeopackage',
  initialState,
  reducers: {},
  extraReducers: (builder: ActionReducerMapBuilder<NoInfer<State<GeoJSONFeatureCollection | undefined>>>) => {
    builder.addCase(
      convertGeoJSONToGeopackage.pending,
      (state: Draft<State<GeoJSONFeatureCollection | undefined>>, action: PendingActionType) => pending(state, action)
    );
    builder.addCase(
      convertGeoJSONToGeopackage.fulfilled,
      (state: Draft<State<GeoJSONFeatureCollection | undefined>>, action: FulfilledActionType<string>) =>
        fulfilled(state, action)
    );
    builder.addCase(
      convertGeoJSONToGeopackage.rejected,
      (state: Draft<State<GeoJSONFeatureCollection | undefined>>, action: RejectedActionType) => rejected(state, action)
    );
  }
});

export default geoJSONToGeopackageSlice.reducer;
